export const EXPANSION_LAST_UPDATED = '2026-03-25'

export const CORE_CLOUD_TARGETS = [
  { bookmaker: 'BallyBet', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'BetMGM', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'BetOnline', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'Bovada', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'DraftKings', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live with WARP path' },
  { bookmaker: 'Fanatics', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'FanDuel', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'Fliff', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'HardRock', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'MyBookie', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'Pinnacle', lane: 'Oracle VM', type: 'Sportsbook', status: 'Production live' },
  { bookmaker: 'BetRivers', lane: 'Oracle VM', type: 'Sportsbook', status: 'Built, not consistently live' },
  { bookmaker: 'Caesars', lane: 'Oracle VM', type: 'Sportsbook', status: 'Token-gated' },
  { bookmaker: 'TheScore / ESPN BET', lane: 'Oracle VM', type: 'Sportsbook', status: 'OAuth-gated' },
  { bookmaker: 'Kalshi', lane: 'Cloudflare Worker', type: 'Prediction market', status: 'Production live' },
  { bookmaker: 'Polymarket', lane: 'Cloudflare Worker', type: 'Prediction market', status: 'Production live' },
]

export const PENDING_CORE_TARGETS = [
  {
    bookmaker: 'BetRivers',
    blocker: 'Current cloud path is not consistently deployed into the VM lane',
    nextStep: 'Promote the existing local source/build into the cloud receiver pipeline',
  },
  {
    bookmaker: 'Caesars',
    blocker: 'Needs current x-aws-waf-token at runtime',
    nextStep: 'Keep the existing WAF-bypass code and feed the token via the managed config path',
  },
  {
    bookmaker: 'TheScore / ESPN BET',
    blocker: 'Needs OAuth refresh token / app-auth runtime flow',
    nextStep: 'Restore the auth bootstrap and token refresh path in cloud',
  },
]

export const ISOLATED_TEAM_BOOKS = [
  {
    bookmaker: 'Winamax',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/winamax_scraper_isolated.py',
    proof: 'ALL 45 / 185 · MLB 60 · NBA 18 · NCAAB 16 · NHL 91',
    output: 'scripts/scrapers/python/output/expansion/winamax-all-20260326-023200.outcomes.json',
    note: 'Direct HTTP is blocked by CloudFront, but the public sport pages still expose anonymous ML / SPREAD / TOTAL ladders in rendered bet-group cards. The shared Winamax support ties those cards back to PRELOADED_STATE match ids so the rows land in the same exact-bet lane as the rest of the board.',
  },
  {
    bookmaker: 'PMU',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/pmu_scraper_isolated.py',
    proof: 'ALL 38 / 805 · NBA 486 · MLB 229 · NHL 90',
    output: 'scripts/scrapers/python/output/expansion/pmu-all-20260326-014223.outcomes.json',
    note: 'Public `sportsbook/rest/v2` league and match feeds expose anonymous PMU ladders, and the shared PMU support now recovers exact ML / SPREAD / TOTAL rows through a modular featured-board + odd-type strategy.',
  },
  {
    bookmaker: 'Betsafe',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/betsafe_scraper_isolated.py',
    proof: 'ALL 28 / 154 · NBA 64 · MLB 90',
    output: 'scripts/scrapers/python/output/expansion/betsafe-all-20260326-012031.outcomes.json',
    note: 'Uses the shared Betsson-family support with browser-captured sportsbook widget requests; exact-bet overlap already verifies the same ML / SPREAD / TOTAL rows against Betsson, LiveScore Bet, Betway, and Matchbook.',
  },
  {
    bookmaker: 'Betsson',
    type: 'Sportsbook',
    status: 'Built + live-proven + receiver/Supabase live',
    path: 'scripts/scrapers/python/betsson_scraper_isolated.py',
    proof: 'ALL 52 / 272 · MLB 90 · NBA 64 · NHL 60 · NCAAB 58',
    output: 'scripts/scrapers/python/output/expansion/betsson-all-20260325-230208.outcomes.json',
    note: 'Betsson’s sportsbook widgets expose view + events-table payloads with exact ML / SPREAD / TOTAL ladders. The scraper now posts into the live receiver and Supabase with the same exact-bet join model as the existing books.',
  },
  {
    bookmaker: 'BetAnything',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/betanything_scraper_isolated.py',
    proof: 'ALL 12 / 72 · MLB 48 · NBA 18 · NHL 6',
    output: 'scripts/scrapers/python/output/expansion/betanything-all-20260325-194832.outcomes.json',
    note: 'Public sports-betting.data route resolves to 17 sportsbook cards; the scraper normalizes the exposed ML / SPREAD / TOTAL offers directly from that route payload.',
  },
  {
    bookmaker: 'Betr AU',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/betr_au_scraper_isolated.py',
    proof: 'ALL 27 / 54 · NBA 3 / 6 · MLB 8 / 16 · NHL 8 / 16 · NCAAB 8 / 16',
    output: 'scripts/scrapers/python/output/expansion/betr_au-all-*.outcomes.json',
    note: 'The public Betr AU homepage ships a live Next.js `/_next/data/<buildId>/index.json` payload with featured moneyline cards for NBA, March Madness, MLB, and NHL. The shared support resolves the current build id each run and normalizes those two-way offers into the same exact-bet team-book lane as the rest of the board.',
  },
  {
    bookmaker: 'PlayUp',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/playup_scraper_isolated.py',
    proof: 'ALL 39 / 208 · MLB 60 · NBA 42 · NHL 52 · NCAAB 54',
    output: 'scripts/scrapers/python/output/expansion/playup-all.outcomes.json',
    note: 'PlayUp’s public NextBet sportsbook APIs expose anonymous event and primary-market payloads, so the scraper stays thin on top of the shared nextbet_support module while still landing in the same exact-bet lane as the rest of the board.',
  },
  {
    bookmaker: 'Coral',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/coral_scraper_isolated.py',
    proof: 'ALL 18 events / 32 outcomes · MLB 2 · NBA 8 · NHL 20 · NCAAB 2',
    output: 'scripts/scrapers/python/output/expansion/coral-all.outcomes.json',
    note: 'Coral’s public CMS sport-page feeds already expose event cards, market ladders, and American prices, so the scraper stays thin on top of the shared coral_cms_support module and still joins the same team-market lane as the rest of the board.',
  },
  {
    bookmaker: 'betPARX',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/betparx_scraper_isolated.py',
    proof: 'ALL 50 / 288 · NBA 12 / 72 · MLB 15 / 78 · NHL 15 / 90 · NCAAB 8 / 48',
    output: 'scripts/scrapers/python/output/expansion/betparx-ncaab-20260325-143024.outcomes.json',
    note: 'The Maryland betPARX sportsbook shell exposes public Kambi endpoints (`parxusmd`), so the scraper stays as a thin wrapper over the shared Kambi support.',
  },
  {
    bookmaker: 'ATG',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/atg_scraper_isolated.py',
    proof: 'ALL 50 / 288 · NBA 12 / 72 · MLB 15 / 78 · NHL 15 / 90 · NCAAB 8 / 48',
    output: 'scripts/scrapers/python/output/expansion/atg_se-ncaab-20260325-162426.outcomes.json',
    note: 'ATG Sweden exposes anonymous Kambi offering endpoints (`atg`) through the public sportsbook shell, so the scraper stays modular as a thin wrapper over the shared Kambi support.',
  },
  {
    bookmaker: 'Svenska Spel',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/svenskaspel_scraper_isolated.py',
    proof: 'ALL 51 / 294 · NBA 13 / 78 · MLB 15 / 78 · NHL 15 / 90 · NCAAB 8 / 48',
    output: 'scripts/scrapers/python/output/expansion/svenskaspel_se-ncaab-20260325-163010.outcomes.json',
    note: 'Svenska Spel Sweden exposes anonymous Kambi offering endpoints (`svenskaspel`) through the public sportsbook shell, so the scraper stays modular as a thin wrapper over the shared Kambi support.',
  },
  {
    bookmaker: 'LiveScore Bet',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/livescorebet_scraper_isolated.py',
    proof: 'ALL 44 / 2,506 · NBA 1,562 · NCAAB 742 · MLB 106 · NHL 96',
    output: 'scripts/scrapers/python/output/expansion/livescorebet-all-20260325-192529.outcomes.json',
    note: 'Public sportsbook gateway payloads already include the match ladders for ML / SPREAD / TOTAL, so the scraper can stay as a thin wrapper over the shared LiveScore-family gateway module.',
  },
  {
    bookmaker: 'Virgin Bet',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/virginbet_scraper_isolated.py',
    proof: 'ALL 44 / 2,506 · NBA 1,562 · NCAAB 742 · MLB 106 · NHL 96',
    output: 'scripts/scrapers/python/output/expansion/virginbet-all-20260325-192529.outcomes.json',
    note: 'Runs on the same shared gateway-family support as LiveScore Bet, which keeps the implementation modular while still emitting exact-bet-compatible Outcome[] rows.',
  },
  {
    bookmaker: 'TABtouch',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/tabtouch_scraper_isolated.py',
    proof: 'ALL 50 / 288 · NBA 12 / 72 · MLB 15 / 78 · NHL 15 / 90 · NCAAB 8 / 48',
    output: 'scripts/scrapers/python/output/expansion/tabtouch-ncaab-20260325-141649.outcomes.json',
    note: 'TABtouch exposes public Kambi offering endpoints; the scraper is a thin wrapper over the shared Kambi support with the operator-specific host/order config.',
  },
  {
    bookmaker: 'NetBet',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/netbet_scraper_isolated.py',
    proof: 'ALL 18 / 431 · MLB 233 · NBA 22 · NCAAB 176',
    output: 'scripts/scrapers/python/output/expansion/netbet-all-20260326-031146.outcomes.json',
    note: 'NetBet blocks direct anonymous HTTP from this environment, but the public event pages still expose anonymous ML / SPREAD / TOTAL ladders in the rendered DOM. The shared browser-backed support filters candidate event links from the sport pages, parses event titles for league/team identity, and keeps exact-bet overlap with PMU, Matchbook, Betway, and LiveScore Bet in the same join lane.',
  },
  {
    bookmaker: 'Unibet AU',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/unibet_au_scraper_isolated.py',
    proof: 'ALL 50 / 288 · NBA 12 / 72 · MLB 15 / 78 · NHL 15 / 90 · NCAAB 8 / 48',
    output: 'scripts/scrapers/python/output/expansion/unibet_au-ncaab-20260325-145620.outcomes.json',
    note: 'Unibet Australia exposes public Kambi offering endpoints (`ubau`), so the scraper stays modular as a thin wrapper over the shared Kambi support and is already posting into the live receiver/Supabase lane.',
  },
  {
    bookmaker: 'Unibet FR',
    type: 'Sportsbook',
    status: 'Built + live-proven (NBA + NCAAB safe subset)',
    path: 'scripts/scrapers/python/unibet_fr_browser_scraper_isolated.py',
    proof: 'NBA 3 / 62 · NCAAB 8 / 176',
    output: 'scripts/scrapers/python/output/expansion/unibet_fr_browser-ncaab-20260326-035300.outcomes.json',
    note: 'The browser-backed Unibet FR path is clean on NBA and NCAAB, so the dashboard feed only includes those safe leagues for now while French NHL normalization stays out of the main join lane.',
  },
  {
    bookmaker: 'Betway',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/betway_scraper_isolated.py',
    proof: 'NBA 12 / 72 · MLB 14 / 84 · NHL 2 / 12',
    output: 'scripts/scrapers/python/output/expansion/betway-mlb-20260325-070250.outcomes.json',
    note: 'Public sport group pages embed full event / market / outcome maps in the Next.js flight payload.',
  },
  {
    bookmaker: 'Novig',
    type: 'Exchange',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/novig_scraper_isolated.py',
    proof: 'NBA 4 / 318 · MLB 1 / 23 · NHL 15 / 240 · NCAAB 12 / 639',
    output: 'scripts/scrapers/python/output/expansion/novig-ncaab-20260324-120543.outcomes.json',
    note: 'Anonymous GraphQL emits ABET-compatible Outcome[] with canonical_id grouping.',
  },
  {
    bookmaker: 'BetOpenly',
    type: 'Exchange',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/betopenly_scraper_isolated.py',
    proof: 'ALL 23 / 37 · NCAAB 9 / 22',
    output: 'scripts/scrapers/python/output/expansion/betopenly-all-20260324-123448.outcomes.json',
    note: 'Public livefeed works anonymously; keeps team-sport ML / SPREAD / TOTAL only.',
  },
  {
    bookmaker: 'Everygame',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/everygame_scraper_isolated.py',
    proof: 'ALL 23 / 138 · NBA 12 games · MLB 1 game · NHL 2 games · NCAAB 8 games',
    output: 'scripts/scrapers/python/output/expansion/everygame-all-20260325-055911.outcomes.json',
    note: 'Public pre-rendered sportsbook HTML exposes ML / SPREAD / TOTAL directly without authenticated APIs.',
  },
  {
    bookmaker: 'ProphetX',
    type: 'Exchange',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/prophetx_scraper_isolated.py',
    proof: 'NBA 4 / 104 · NCAAB 12 / 239',
    output: 'scripts/scrapers/python/output/expansion/prophetx-ncaab-20260324-173951.outcomes.json',
    note: 'Public event + v2 market APIs emit exact ML / SPREAD / TOTAL rows with liquidity.',
  },
  {
    bookmaker: 'ReBet',
    type: 'Sportsbook / social',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/rebet_scraper_isolated.py',
    proof: 'NBA 5 / 638 · NCAAB 14 / 650 · ALL 19 / 1,288',
    output: 'scripts/scrapers/python/output/expansion/rebet-all-20260324-201253.outcomes.json',
    note: 'Public catalog + boards + event detail endpoints are enough for the team-sport lane.',
  },
  {
    bookmaker: 'Sporttrade',
    type: 'Exchange',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/sporttrade_scraper_isolated.py',
    proof: 'NBA 8 / 104 · ALL 26 / 325',
    output: 'scripts/scrapers/python/output/expansion/sporttrade-all-20260325-014852.outcomes.json',
    note: 'Anonymous snapshot stream + market-prices endpoint normalized to comparable American odds.',
  },
  {
    bookmaker: 'Matchbook',
    type: 'Exchange',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/matchbook_scraper_isolated.py',
    proof: 'NBA 11 / 213 · ALL 29 / 455',
    output: 'scripts/scrapers/python/output/expansion/matchbook-all-20260325-015728.outcomes.json',
    note: 'Public exchange feed supports NBA / NCAAB / MLB / NHL with normalized team abbreviations.',
  },
  {
    bookmaker: 'Smarkets',
    type: 'Exchange',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/smarkets_scraper_isolated.py',
    proof: 'ALL 6 / 8 · NBA only so far · latest-trade price lane',
    output: 'scripts/scrapers/python/output/expansion/smarkets-all-20260325-063055.outcomes.json',
    note: 'Public api.smarkets.com event / market / contract / recent-trade APIs are working; current implementation uses the latest public trade price per contract.',
  },
  {
    bookmaker: 'Marathonbet',
    type: 'Sportsbook',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/marathonbet_scraper_isolated.py',
    proof: 'ALL 22 / 280 · NBA 216 · NCAAB 48 · NHL 16',
    output: 'scripts/scrapers/python/output/expansion/marathonbet-all-20260325-060507.outcomes.json',
    note: 'Public coupon-row markup exposes team metadata plus ML / SPREAD / TOTAL price cells directly in the page.',
  },
]

export const ISOLATED_PROPS_BOOKS = [
  {
    bookmaker: 'PrizePicks',
    type: 'Props / pick’em',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/prizepicks_scraper_isolated.py',
    proof: 'Historic NBA 7,620 · Historic NHL 2,792 · Live NFL 162',
    output: 'scripts/scrapers/python/output/expansion/prizepicks-nfl-20260324-122349.projections.json',
    note: 'Emits projection rows for a dedicated props lane, not team-sport Outcome[] rows.',
  },
  {
    bookmaker: 'Underdog',
    type: 'Props / pick’em',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/underdog_scraper_isolated.py',
    proof: 'ALL 7,507 · NBA 543 · Tennis 577',
    output: 'scripts/scrapers/python/output/expansion/underdog-all-20260324-153901.projections.json',
    note: 'Public over/under feed emits player props plus higher/lower prices.',
  },
  {
    bookmaker: 'DraftKings Pick6',
    type: 'Props / pick’em',
    status: 'Built + live-proven',
    path: 'scripts/scrapers/python/draftkings_pick6_scraper_isolated.py',
    proof: 'NBA Points 53 · NHL Shots On Goal 64',
    output: 'scripts/scrapers/python/output/expansion/pick6-nba-20260324-161924.projections.json',
    note: 'Playwright-driven scrape of rendered cards plugs into the shared projection identity layer.',
  },
]

export const TEAM_MATCHING_PROOF = [
  {
    pair: 'Winamax vs LiveScore Bet',
    sharedEvents: 33,
    exactKeys: 58,
    note: 'Winamax’s browser-only ladders are already landing on the same canonical event plus market/selection/handicap keys as the LiveScore-family books.',
  },
  {
    pair: 'Winamax vs PMU',
    sharedEvents: 32,
    exactKeys: 14,
    note: 'Winamax’s French public pages and PMU’s French REST ladders overlap on the same exact ML / SPREAD / TOTAL keys where line coverage matches.',
  },
  {
    pair: 'Winamax vs Matchbook',
    sharedEvents: 14,
    exactKeys: 6,
    note: 'Even against the exchange lane, Winamax is producing the same normalized event-side-line identity instead of isolated event containers.',
  },
  {
    pair: 'Winamax vs Betway',
    sharedEvents: 18,
    exactKeys: 2,
    note: 'Winamax is already joining the fixed-odds sportsbook lane on the same canonical events; low exact-key overlap here is current line-selection drift, not event mismatch.',
  },
  {
    pair: 'PMU vs LiveScore Bet',
    sharedEvents: 35,
    exactKeys: 56,
    note: 'PMU’s French public REST ladders are landing in the same canonical event plus market/selection/handicap keys as the LiveScore-family sportsbook lane.',
  },
  {
    pair: 'PMU vs Betsson',
    sharedEvents: 36,
    exactKeys: 30,
    note: 'PMU overlaps directly with the Betsson-family sportsbook lane on exact team-sport rows instead of fragmenting into its own event containers.',
  },
  {
    pair: 'PMU vs Betway',
    sharedEvents: 21,
    exactKeys: 16,
    note: 'PMU is already joining the fixed-odds sportsbook lane on the same exact ML / SPREAD / TOTAL offers where coverage overlaps.',
  },
  {
    pair: 'PMU vs Matchbook',
    sharedEvents: 13,
    exactKeys: 1,
    note: 'Even with the exchange lane, PMU is producing the same normalized event-side-line keys rather than isolated provider-specific rows.',
  },
  {
    pair: 'Betsson vs LiveScore Bet',
    sharedEvents: 41,
    exactKeys: 164,
    note: 'Betsson is landing on the same canonical event and exact market/selection/handicap keys as the LiveScore-family books.',
  },
  {
    pair: 'Betsson vs Betway',
    sharedEvents: 27,
    exactKeys: 96,
    note: 'Betsson’s team-sport rows are joining directly against another fixed-odds sportsbook lane, not fragmenting into their own event containers.',
  },
  {
    pair: 'Betsson vs Matchbook',
    sharedEvents: 18,
    exactKeys: 63,
    note: 'Betsson also overlaps cleanly with the exchange lane, which is the exact same-bet proof we need for the main odds board.',
  },
  {
    pair: 'BetAnything vs LiveScore Bet',
    sharedEvents: 12,
    exactKeys: 54,
    note: 'The resolved BetAnything route payload lands on the same exact-bet identity as the LiveScore gateway-family books.',
  },
  {
    pair: 'Betr AU vs Betway',
    sharedEvents: 7,
    exactKeys: 14,
    note: 'Betr AU’s homepage moneyline cards already land on the same canonical event and team-side keys as the current fixed-odds sportsbook lane.',
  },
  {
    pair: 'Betr AU vs LiveScore Bet',
    sharedEvents: 18,
    exactKeys: 22,
    note: 'Betr AU joins the existing event containers cleanly on team-sport moneyline rows instead of fragmenting into a separate provider-only view.',
  },
  {
    pair: 'PlayUp vs LiveScore Bet',
    sharedEvents: 32,
    exactKeys: 46,
    note: 'PlayUp’s primary-market rows are already landing in the same canonical event plus market/selection/handicap lane as the LiveScore gateway books.',
  },
  {
    pair: 'PlayUp vs Virgin Bet',
    sharedEvents: 32,
    exactKeys: 46,
    note: 'PlayUp is joining against the same gateway-family sportsbook event containers instead of splintering off by provider-specific labels.',
  },
  {
    pair: 'PlayUp vs Betway',
    sharedEvents: 19,
    exactKeys: 18,
    note: 'The NextBet lane overlaps cleanly with an existing fixed-odds sportsbook lane on exact ML / SPREAD / TOTAL offers.',
  },
  {
    pair: 'PlayUp vs Betsson',
    sharedEvents: 33,
    exactKeys: 22,
    note: 'PlayUp’s normalized outcomes line up with the Betsson-family sportsbook lane on exact event-side-line identity.',
  },
  {
    pair: 'PlayUp vs Matchbook',
    sharedEvents: 14,
    exactKeys: 2,
    note: 'Even against the exchange lane, PlayUp is producing the same normalized exact-bet keys rather than isolated event containers.',
  },
  {
    pair: 'Coral vs Betway',
    sharedEvents: 6,
    exactKeys: 12,
    note: 'Coral’s CMS feed is already landing on the same canonical event plus market/selection/handicap keys as the fixed-odds sportsbook lane.',
  },
  {
    pair: 'Coral vs LiveScore Bet',
    sharedEvents: 7,
    exactKeys: 10,
    note: 'Coral joins the gateway-family books on the same normalized team-side rows instead of creating its own event container.',
  },
  {
    pair: 'Coral vs Virgin Bet',
    sharedEvents: 7,
    exactKeys: 10,
    note: 'Coral is already aligning with another sportsbook family on exact moneyline rows in the same event containers.',
  },
  {
    pair: 'Coral vs Matchbook',
    sharedEvents: 5,
    exactKeys: 10,
    note: 'The Coral CMS lane also joins against the exchange lane on the same exact-bet keys where market coverage overlaps.',
  },
  {
    pair: 'betPARX vs Betway',
    sharedEvents: 24,
    exactKeys: 80,
    note: 'betPARX lands directly in the same exact-bet lane as the existing Kambi/fixed-odds sportsbook books.',
  },
  {
    pair: 'betPARX vs Matchbook',
    sharedEvents: 15,
    exactKeys: 62,
    note: 'betPARX is already aligning with the exchange lane on exact event/side/line keys.',
  },
  {
    pair: 'betPARX vs TABtouch',
    sharedEvents: 38,
    exactKeys: 172,
    note: 'Two separate Kambi operators are now joining strongly on the same normalized team-market rows.',
  },
  {
    pair: 'ATG vs TABtouch',
    sharedEvents: 50,
    exactKeys: 256,
    note: 'ATG lands directly in the same Kambi exact-bet lane as TABtouch across NBA, MLB, NHL, and NCAAB without fragmenting into separate event containers.',
  },
  {
    pair: 'ATG vs Unibet AU',
    sharedEvents: 50,
    exactKeys: 256,
    note: 'ATG and Unibet AU are joining on the same canonical event plus market/selection/handicap keys, which is the exact behavior we need for the main odds board.',
  },
  {
    pair: 'ATG vs Matchbook',
    sharedEvents: 15,
    exactKeys: 52,
    note: 'ATG also aligns with the exchange lane on the same exact-bet rows instead of creating its own isolated event containers.',
  },
  {
    pair: 'ATG vs Betway',
    sharedEvents: 26,
    exactKeys: 72,
    note: 'ATG overlaps with the fixed-odds sportsbook lane on the same exact offers, which proves the normalized join is holding across providers.',
  },
  {
    pair: 'Svenska Spel vs ATG',
    sharedEvents: 50,
    exactKeys: 274,
    note: 'Svenska Spel lands in the same Swedish Kambi exact-bet lane as ATG across NBA, MLB, NHL, NFL, and NCAAB without fragmenting into separate event containers.',
  },
  {
    pair: 'Svenska Spel vs TABtouch',
    sharedEvents: 50,
    exactKeys: 260,
    note: 'Svenska Spel is joining directly against the Australian Kambi lane on the same canonical event plus market/selection/handicap keys.',
  },
  {
    pair: 'Svenska Spel vs Unibet AU',
    sharedEvents: 50,
    exactKeys: 262,
    note: 'Svenska Spel and Unibet AU are aligning on the same exact team-sport offers, which is the behavior we need for the main odds board.',
  },
  {
    pair: 'Svenska Spel vs Matchbook',
    sharedEvents: 15,
    exactKeys: 52,
    note: 'Svenska Spel also aligns with the exchange lane on exact-bet rows instead of creating its own isolated event containers.',
  },
  {
    pair: 'BetAnything vs Virgin Bet',
    sharedEvents: 12,
    exactKeys: 54,
    note: 'Same public cards, same event dates, and the same favorite/dog spread semantics normalize cleanly.',
  },
  {
    pair: 'BetAnything vs Betway',
    sharedEvents: 11,
    exactKeys: 40,
    note: 'Fixed-odds rows from the public BetAnything board are already joining to the existing sportsbook lane.',
  },
  {
    pair: 'BetAnything vs Matchbook',
    sharedEvents: 7,
    exactKeys: 30,
    note: 'The new sportsbook rows overlap with the exchange lane without special-case joining logic.',
  },
  {
    pair: 'LiveScore Bet vs Virgin Bet',
    sharedEvents: 44,
    exactKeys: 2506,
    note: 'Both books ride the same gateway family and fully align on exact team-sport bet keys.',
  },
  {
    pair: 'TABtouch vs BetOpenly',
    sharedEvents: 6,
    exactKeys: 5,
    note: 'The TABtouch Kambi lane is normalizing into the same exact event/side/line keys as the existing exchange lane.',
  },
  {
    pair: 'TABtouch vs Matchbook',
    sharedEvents: 15,
    exactKeys: 58,
    note: 'TABtouch aligns cleanly with the existing exchange/fixed-odds board on exact-bet rows.',
  },
  {
    pair: 'TABtouch vs Betway',
    sharedEvents: 26,
    exactKeys: 80,
    note: 'TABtouch shares strong overlap with the existing fixed-odds sportsbook lane across NBA, MLB, NHL, NFL, and NCAAB.',
  },
  {
    pair: 'Unibet AU vs Betway',
    sharedEvents: 12,
    exactKeys: 34,
    note: 'Unibet AU is landing on the same exact event/side/line rows as the existing fixed-odds sportsbook lane.',
  },
  {
    pair: 'Unibet AU vs Matchbook',
    sharedEvents: 12,
    exactKeys: 48,
    note: 'The Unibet AU Kambi lane is already aligning cleanly with the exchange lane on exact-bet identity.',
  },
  {
    pair: 'Unibet AU vs TABtouch',
    sharedEvents: 12,
    exactKeys: 58,
    note: 'Two separate Australian Kambi operators are now joining strongly on the same normalized team-market rows.',
  },
  {
    pair: 'LiveScore Bet vs Betway',
    sharedEvents: 26,
    exactKeys: 100,
    note: 'The new gateway-family books are already landing on the same exact-bet lane as existing fixed-odds books.',
  },
  {
    pair: 'LiveScore Bet vs Matchbook',
    sharedEvents: 15,
    exactKeys: 202,
    note: 'Exchange and fixed-odds rows are joining on the same canonical event + side + line identity.',
  },
  {
    pair: 'ReBet vs ProphetX (NBA)',
    sharedEvents: 3,
    exactKeys: 82,
    note: 'Exact key = canonical_id + market_normalized + selection + handicap',
  },
  {
    pair: 'Sporttrade vs ProphetX (NBA)',
    sharedEvents: 2,
    exactKeys: 22,
    note: 'Exchange-priced rows still land in the same exact market identity lane.',
  },
  {
    pair: 'Sporttrade vs ReBet (NBA)',
    sharedEvents: 3,
    exactKeys: 34,
    note: 'Back/lay style pricing can still align to the same underlying team-side and line.',
  },
  {
    pair: 'Matchbook vs Sporttrade (NBA)',
    sharedEvents: 8,
    exactKeys: 85,
    note: 'Strongest team-lane proof so far across two separate exchange products.',
  },
  {
    pair: 'Matchbook vs ReBet (NBA)',
    sharedEvents: 4,
    exactKeys: 52,
    note: 'Normalized abbreviations and handicap keys are joining cleanly.',
  },
  {
    pair: 'Smarkets vs Matchbook (NBA)',
    sharedEvents: 4,
    exactKeys: 4,
    note: 'Latest-trade exchange rows are already landing in the same exact-bet key lane.',
  },
  {
    pair: 'Smarkets vs Sporttrade (NBA)',
    sharedEvents: 2,
    exactKeys: 3,
    note: 'Even the sparse public trade lane aligns to existing exchange-market identities.',
  },
]

export const PROPS_MATCHING_PROOF = [
  {
    pair: 'PrizePicks vs Underdog (NBA)',
    sharedGroups: 326,
    exactMatches: 241,
    note: 'projection_group_id groups the same player/stat/game; projection_canonical_id locks exact same-line matches.',
  },
  {
    pair: 'Pick6 vs PrizePicks (NBA)',
    sharedGroups: 48,
    exactMatches: 33,
    note: 'Pick6 already lands in the same props identity lane as PrizePicks.',
  },
  {
    pair: 'Pick6 vs Underdog (NBA)',
    sharedGroups: 46,
    exactMatches: 29,
    note: 'Concrete three-book exact match exists for Brandon Miller 20.5 points.',
  },
]

export const MARKET_IDENTITY_RULES = [
  {
    lane: 'Team sports',
    key: 'canonical_id + market_normalized + selection + handicap',
    detail: 'This is the exact join key for ML / SPREAD / TOTAL rows across fixed-odds books and exchanges.',
  },
  {
    lane: 'Props / pick’em',
    key: 'projection_group_id',
    detail: 'Broad same-player / same-stat / same-game grouping across books.',
  },
  {
    lane: 'Props / pick’em',
    key: 'projection_canonical_id',
    detail: 'Exact same-bet key when the player, stat, side, and line all match.',
  },
]

export const THEODDSAPI_REGION_SUMMARY = [
  { region: 'US + US2 sportsbooks', count: 18 },
  { region: 'US DFS / pick’em', count: 4 },
  { region: 'US exchanges / prediction', count: 5 },
  { region: 'UK', count: 19 },
  { region: 'EU', count: 29 },
  { region: 'Australia', count: 13 },
  { region: 'France', count: 6 },
  { region: 'Sweden', count: 9 },
]

export const NEXT_TARGETS = [
  {
    bookmaker: 'Betr Picks',
    type: 'Props / pick’em',
    blocker: 'No stable anonymous app/API surface recovered yet',
  },
  {
    bookmaker: 'OnyxOdds',
    type: 'Sweepstakes / social',
    blocker: 'Current app bundle points at OpticOdds APIs that require keys',
  },
  {
    bookmaker: 'Betfair Exchange',
    type: 'Exchange',
    blocker: 'Discovery and normalization work still needed for the public market feed path',
  },
  {
    bookmaker: 'UK / AU / EU regulated books',
    type: 'Sportsbook family',
    blocker: 'Need family-by-family discovery once the current US expansion lane is promoted',
  },
]

export const PIPELINE_STORAGE_NOTES = [
  {
    lane: 'live_odds',
    mode: 'UPSERT snapshot',
    detail: 'Current board state per unique compound key. This is the table the deployed Live Odds widget reads.',
  },
  {
    lane: 'odds_history',
    mode: 'INSERT deltas only',
    detail: 'Only changed prices are appended, with recorded_at, previous_odds, and odds_movement.',
  },
  {
    lane: 'scraper_status',
    mode: 'UPSERT poll telemetry',
    detail: 'Each receiver ingest updates outcomes_count, delta_count, cycle_time_ms, and status per bookmaker.',
  },
]
